export const flipMatchResult = (result) => {
  const normalized = (result || '').toString().trim().toLowerCase();
  if (normalized === 'win' || normalized === 'w') return 'Lose';
  if (normalized === 'lose' || normalized === 'loss' || normalized === 'l') return 'Win';
  if (normalized === 'tie' || normalized === 't' || normalized === 'draw') return result;
  return result;
};

export const buildMirrorSubmissionData = (data) => ({
  ...data,
  Team: data.EnemyTeam,
  TeamRegion: data.EnemyRegion,
  EnemyTeam: data.Team,
  EnemyRegion: data.TeamRegion,
  PF: data.PA,
  PA: data.PF,
  WinLose: flipMatchResult(data.WinLose),
});
